/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Onboarding_Paywall_Early_Bird_OfferInputs */

const en_onboarding_paywall_early_bird_offer = /** @type {(inputs: Onboarding_Paywall_Early_Bird_OfferInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Limited-Time Early Bird Offer`)
};

const ar_onboarding_paywall_early_bird_offer = /** @type {(inputs: Onboarding_Paywall_Early_Bird_OfferInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`عرض الحجز المبكر لفترة محدودة`)
};

const de_onboarding_paywall_early_bird_offer = /** @type {(inputs: Onboarding_Paywall_Early_Bird_OfferInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zeitlich begrenztes Frühbucherangebot`)
};

const es_onboarding_paywall_early_bird_offer = /** @type {(inputs: Onboarding_Paywall_Early_Bird_OfferInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gana 3 veces más recompensas para desbloquear nuevos árboles más rápido.`)
};

const fr_onboarding_paywall_early_bird_offer = /** @type {(inputs: Onboarding_Paywall_Early_Bird_OfferInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Offre spéciale lancement - Durée limitée`)
};

const it_onboarding_paywall_early_bird_offer = /** @type {(inputs: Onboarding_Paywall_Early_Bird_OfferInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Offerta Early Bird a tempo limitato`)
};

const ja_onboarding_paywall_early_bird_offer = /** @type {(inputs: Onboarding_Paywall_Early_Bird_OfferInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`期間限定の早期割引オファー`)
};

const ko_onboarding_paywall_early_bird_offer = /** @type {(inputs: Onboarding_Paywall_Early_Bird_OfferInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`기간 한정 얼리버드 혜택`)
};

const pt_br_onboarding_paywall_early_bird_offer = /** @type {(inputs: Onboarding_Paywall_Early_Bird_OfferInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ofertas antecipadas por tempo limitado`)
};

const ru_onboarding_paywall_early_bird_offer = /** @type {(inputs: Onboarding_Paywall_Early_Bird_OfferInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ограниченное предложение для ранних пташек`)
};

const th_onboarding_paywall_early_bird_offer = /** @type {(inputs: Onboarding_Paywall_Early_Bird_OfferInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ข้อเสนอแบบจำกัดเวลาสำหรับผู้ใช้กลุ่มแรก`)
};

const tr_onboarding_paywall_early_bird_offer = /** @type {(inputs: Onboarding_Paywall_Early_Bird_OfferInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sınırlı Süreli Erken Rezervasyon Teklifi`)
};

const zh_cn_onboarding_paywall_early_bird_offer = /** @type {(inputs: Onboarding_Paywall_Early_Bird_OfferInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`早鸟限时特惠`)
};

const zh_tw_onboarding_paywall_early_bird_offer = /** @type {(inputs: Onboarding_Paywall_Early_Bird_OfferInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`早鳥限時優惠`)
};

/**
* | output |
* | --- |
* | "Limited-Time Early Bird Offer" |
*
* @param {Onboarding_Paywall_Early_Bird_OfferInputs} inputs
* @param {{ locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }} options
* @returns {LocalizedString}
*/
export const onboarding_paywall_early_bird_offer = /** @type {((inputs?: Onboarding_Paywall_Early_Bird_OfferInputs, options?: { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Onboarding_Paywall_Early_Bird_OfferInputs, { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_onboarding_paywall_early_bird_offer(inputs)
	if (locale === "ar") return ar_onboarding_paywall_early_bird_offer(inputs)
	if (locale === "de") return de_onboarding_paywall_early_bird_offer(inputs)
	if (locale === "es") return es_onboarding_paywall_early_bird_offer(inputs)
	if (locale === "fr") return fr_onboarding_paywall_early_bird_offer(inputs)
	if (locale === "it") return it_onboarding_paywall_early_bird_offer(inputs)
	if (locale === "ja") return ja_onboarding_paywall_early_bird_offer(inputs)
	if (locale === "ko") return ko_onboarding_paywall_early_bird_offer(inputs)
	if (locale === "pt_br") return pt_br_onboarding_paywall_early_bird_offer(inputs)
	if (locale === "ru") return ru_onboarding_paywall_early_bird_offer(inputs)
	if (locale === "th") return th_onboarding_paywall_early_bird_offer(inputs)
	if (locale === "tr") return tr_onboarding_paywall_early_bird_offer(inputs)
	if (locale === "zh_cn") return zh_cn_onboarding_paywall_early_bird_offer(inputs)
	return zh_tw_onboarding_paywall_early_bird_offer(inputs)
});